<p-dialog [(visible)]="dialogOpen" [style]="{width: '450px'}" header="New Subject" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="form">
            <div class="p-field">
                <label for="name">Subject</label>
                <input type="text" pInputText id="name" formControlName="subjectName" required autofocus />
                <small class="p-invalid" *ngIf="submitted && !product.name">Name is required.</small>
            </div>

            <div class="p-field">
                <label class="p-mb-3">Notify</label>
                <div class="p-formgrid p-grid">
                    <p-dropdown [options]="notifyTypes" optionValue="Value" optionLabel="Label" appendTo="body"
                        formControlName="notifyType" [style]="{'width':'100%'}"></p-dropdown>
                </div>
            </div>

            <div class="p-formgrid p-grid">
                <div class="p-field p-col">
                  <label for="Emails">Individual/Backup Email(s)</label>
                  <p-chips [allowDuplicate]="false"
                           #emails
                           formControlName="emails"
                           [style]="{'width':'100%'}"
                           placeholder="Press enter after each email address"
                           separator=","
                           addOnBlur="true"
                           required>
                    </p-chips>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="cancel()"></button>
      <button pButton pRipple
              [disabled]="!form.valid"
              label="Add"
              icon="pi pi-check"
              class="p-button-text"
              (click)="save()"></button>
    </ng-template>

</p-dialog>
